import { useState } from "react";
import BASE_URL from "../Utilities/BASE_URL";

const useDelete = () => {
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(null);

  const deleteData = async (endpoint, token) => {
    setIsLoading(true);
    setIsError(null);
    setData(null);

    try {
      const headers = {
        "Content-Type": "application/json",
      };

      // Add Authorization header if token is provided
      if (token) {
        headers.Authorization = `Bearer ${token}`;
      }

      const response = await fetch(`${BASE_URL}/${endpoint}`, {
        method: "DELETE",
        headers,
        credentials: "include",
        mode: "cors",
      });

      if (!response.ok) {
        const errorData = await response.json();
        console.log(errorData);
        throw new Error(`Error: ${errorData.message}`);
      }

      const result = await response.json();
      setData(result);
      return result;
    } catch (error) {
      console.log(error);
      setIsError(error.message || "An error occurred while posting data");
      return null;
    } finally {
      setIsLoading(false);
    }
  };

  return { data, isLoading, isError, deleteData };
};

export default useDelete;
